const EnTranslation = {
  subdomainHeader: "Please specify workspace",
  settingsHeader: "Your current workspace",
  next: "Next",
  logout: "Logout",
  subdomain: "Subdomain",
  invalidSubdomain: "Please specify valid subdomain",
  validation: {
    required: "Please fill this field",
    subdomain: {
      minLength: "Subdomain must have min 6 chars",
      notAllowed: "This name is already taken or not allowed",
    },
  },
  loading: {
    title: "Loading",
    subtitle: "The page is loading, just a moment please",
  },
  401: "Your user {{email}} is not activated for account {{domain}}. Please contact your administrator or select a different account.",
  409: "Your account {{email}} has not been activated. Please check your inbox to accept the invitation or contact your Teams administrator.",
  500: "The server didn’t respond. Please try again later or contact support@shiawa.com",
  unknownError: "Unknown Error",
  status: {
    loadingIframe: "Loading iframe",
    tokenRequest: "Requesting token",
    tokenRequestSuccess: "Token received",
  },
  appDisabled: "The app is not approved by the admin to run in your organization",
  ottFailed: "Failed to login. Please try again later",
  loginFailed:
    "We couldn’t log you in with your user account. Please contact your administrator to activate your account in Shiawa",
  signup1: "You don’t have an account yet? Signup ",
  signup2: "here",
  signup3: "",
};

export default EnTranslation;
